import { useState, useEffect } from "react";
import Translate from "../../../Components/MultiLanguage/Translate";

const PlanDetails = ({ planSelected }) => {

  const [image, setImage] = useState(false);

  const plan = planSelected;


  useEffect(() => {
    if (plan?.logo) {
      const img = new Image();
      img.onload = () => setImage(true);
      img.onerror = () => setImage(false);
      img.src = plan.logo;
    }
  }, [plan?.logo]);

  if (!plan) {
    return <div><Translate textKey={'loading'}/></div>;
  }

    return (
        <div className="plan-details-container">
          {image &&
            <div className="plan-banner">
                <img src={plan?.logo} alt={plan?.subscription_name} />
            </div>
           }
            <div className="plan-content">
                <h1 className="plan-title">{plan?.subscription_name}</h1>
                <p className="plan-description">{plan?.description}</p>
                <div className="plan-price">{plan?.subscription_text}</div>
            </div>
        </div>
    );
};

export default PlanDetails;